import React from 'react';

import DropdownToggle from '../../../DropdownToggle';

import styles from './FooterNavColumnTitle.module.css';

export interface FooterNavColumnTitleProps {
  isOpen: boolean;
  title: string;
  toggle(): void;
}

export const FooterNavColumnTitle = ({
  isOpen,
  title,
  toggle
}: FooterNavColumnTitleProps): JSX.Element =>
<div
  className={`${styles.footerNavColumnTitleWrapper} ${
  isOpen && styles.footerNavColumnTitleWrapperOpen}`
  }
  onClick={toggle}>

		<p className={styles.footerNavColumnTitleText}>{title}</p>
		<DropdownToggle isOpen={isOpen} />
	</div>;